import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: anatomy['space-8'],
    padding: `${anatomy['space-4']} ${anatomy['space-8']} `,
    borderRadius: anatomy.borderRadiusRound,
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: typography['lineHeightCaption-2'],
    alignSelf: 'flex-start',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  popover: (minWidth: number | null) => ({
    minWidth: minWidth ?? 'unset',
    marginTop: anatomy['space-4'],
  }),
  menuList: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.primaryText,
    padding: anatomy['space-4'],
    backgroundColor: colors.primaryBackground,
    border: `1px solid ${colors.tertiaryBorder}`,
    borderRadius: anatomy.borderRadiusS,
    display: 'flex',
    flexDirection: 'column',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: anatomy['space-8'],
    padding: `${anatomy['space-8']} ${anatomy['space-12']}`,
    borderRadius: anatomy.borderRadiusXs,
    ':hover': {
      background: colors.hoverBackground,
    },
  },
  selectedItem: {
    color: colors.accentText,
  },
});
